import { render, staticRenderFns } from "./SerialInput.vue?vue&type=template&id=191b926a&"
import script from "./SerialInput.vue?vue&type=script&lang=js&"
export * from "./SerialInput.vue?vue&type=script&lang=js&"
import style0 from "./SerialInput.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports